"use client";

import { IconChevronLeft } from "@tabler/icons-react";
import React from "react";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { Button } from "@components/ui/button";
import { ButtonWithTooltipProps } from "@components/ui/custom/button-with-tooltip";

/**
 * A React functional component that renders a "Back" button with a tooltip.
 *
 * This button allows the user to navigate to the previous page by calling the `router.back()` method.
 * It uses the `useRouter` hook from Next.js to facilitate navigation and the `useTranslations` hook
 * to display localized text for the button label.
 *
 * @param {ButtonWithTooltipProps} props - The properties passed to the button component, which include
 * additional tooltip-related options and button configurations.
 *
 * @returns {JSX.Element} The rendered "Back" button component.
 */
export const BackButton = (props: ButtonWithTooltipProps) => {
  const router = useRouter();
  const t = useTranslations("common.words.verbs");

  return (
    <Button size="lg" onClick={() => router.back()} {...props}>
      <IconChevronLeft className="opacity-50" />
      <span className="text-nowrap">{t("return")}</span>
    </Button>
  );
};
